import React from "react";
import { Checkbox } from "../shared/FormElements";

const DeletePopup = props => {
  const closeModal = () => {
    props.closeModal();
  };
  // const deletePopupStructure = props.form.map((value, index) => <div></div>);
  return (
    <React.Fragment>
      <div className="modal-header border-bottom-0">
        <img src="/assets/svg/alert.svg" className="warningIcon" />
        <h4 className="modal-title heading">Delete your account</h4>
        <button
          type="button"
          className="close cross"
          data-dismiss="modal"
          onClick={() => closeModal()}
        >
         
        </button>
      </div>

      <div className="modal-body">
        <p className="warningmsg">
          Warning: account deletion cannot be undone.
        </p>
        <p className="subheading">To proceed, please confirm the following:</p>

        <label
          htmlFor={props.form.unsetPreferences.id}
          className="chk_container subheading"
        >
          Your preferences will be lost, including companies and topics you
          follow
          <Checkbox
            id={props.form.unsetPreferences.id}
            formName={props.formName}
            checked={props.form.unsetPreferences.value}
            name={props.form.unsetPreferences.name}
            onChangeHandler={props.onChangeHandler}
            checkButton={props.form.unsetPreferences.checkButton}
          />
          <span className="checkmark"></span>
        </label>

        <label
          htmlFor={props.form.deleteUser.id}
          className="chk_container subheading"
        >
          This will delete your account on all devices
          <Checkbox
            id={props.form.deleteUser.id}
            formName={props.formName}
            checked={props.form.deleteUser.value}
            name={props.form.deleteUser.name}
            onChangeHandler={props.onChangeHandler}
            checkButton={props.form.deleteUser.checkButton}
          />
          <span className="checkmark"></span>
        </label>

        <div className="modal-footer border-top-0 ">
          <button
            type="submit"
            className="btn cancelBtn"
            onClick={() => closeModal()}
          >
            Cancel
          </button>
          <button
            type="submit"
            className={
              props.btnDisabled ? "btn deleteBtn" : "btn deleteBtn active"
            }
            disabled={props.btnDisabled ? "disabled" : ""}
            onClick={() => props.sucessHandler()}
          >
            Delete
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DeletePopup;
